<template>
  <div class="lovexz_container">
    <MySwiper
      :picData="pictureData.kindness.top_banner"
      :swiperOption="swiperOption"
    />

    <div class="lovexz_center">
      <div class="lovexz_title">爱心修正</div>
      <div class="lovexz_img_wrap1" ref="rotationImg">
        <div class="lovexz_img_wrap2">
          <template v-for="(key, index) in ['one', 'two']">
            <infinite-slide-bar
              :key="index"
              :direction="index === 1 ? 'reverse' : 'normal'"
              duration="40s"
            >
              <div
                class="lovexz_item"
                v-for="(item, index) in key == 'one'
                  ? chosenList_one
                  : chosenList_two"
                :key="index"
                @mouseenter="onMouseEvent(true)"
                @mouseleave="onMouseEvent(false)"
              >
                <div
                  v-if="item.article_type==1"
                  @click="goDetailArticle(item.article_id)"
                >
                  <img class="lovexz_img_item" :src="item.image" alt="" />
                  <div class="mask_wrap">
                    <div class="mask">
                      <div class="mask_detail">
                        {{ item.title }}
                      </div>
                      <div class="mask_look">查看详情</div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="video_icon_wipper" v-if="item.video_path">
                    <img
                      class="video_icon"
                      src="@/assets/image/video.png"
                      alt=""
                    />
                  </div>
                  <img class="lovexz_img_item" :src="item.image" alt="" />
                  <div class="mask_wrap" @click="goLookVideo(item.id)">
                    <div class="mask">
                      <div class="mask_detail">
                        {{ item.kindness_title }}
                      </div>
                      <div class="mask_look">查看详情</div>
                    </div>
                  </div>
                </div>
              </div>
            </infinite-slide-bar>
          </template>
          <div class="look_video_mask" v-if="lookVideo">
            <div class="back_lovexz" @click="backLovexz()">
              <img src="../../assets/image/close.png" alt="" />
            </div>
            <div class="look_video_box">
              <video playsinline webkit-playsinline autoplay loop controls>
                <source
                  :src="videoSrc"
                  type='video/mp4; codecs="avc1.4D401E, mp4a.40.2'
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="love_btn" @click="$router.push('/alllove')">查看更多</div>
    <div class="love_origin">
      <div class="love_origin_title">{{ kindness.title }}</div>
      <div class="love_origin_content">
        <span v-if="!isOpen && newValue.length > 100">
          {{ newValue }}
          <span> [<span class="detail" @click="more">详情</span>]</span>
        </span>
        <span v-else>
          {{ kindness.content }}
        </span>
      </div>
      <div class="love_origin_wrap">
        <div
          class="love_origin_item"
          :key="index"
          v-for="(item, index) in pictureData.kindness.illustration"
        >
          <img class="love_origin_item_img" :src="item.url" alt="" />

          <div v-if="index == 0" class="love_origin_item_tit">责任</div>
          <div v-if="index == 1" class="love_origin_item_tit">良心</div>
          <div v-if="index == 2" class="love_origin_item_tit">奉献</div>
        </div>
      </div>
    </div>
    <Tabs :navList="navList" />
  </div>
</template>

<script>
import Tabs from "@/components/common/tabs.vue";
import MySwiper from "@/components/common/swiper.vue";
import { mapState } from "vuex";
import { getKindnessIndex } from "@/api";
export default {
  name: "LoveXiuZheng",
  data() {
    return {
      isOpen: false,
      newValue: "",
      navList: [],
      kindness: [],
      chosenList: [],
      isSlide: false,
      swiperOption: {
        loop: true, // 是否循环播放
        speed: 400, // 切换速度 ms
        // allowTouchMove: false, // 是否允许鼠标滑动
        // touchRatio: 0.5,
        // touchAngle: 10, // 是否允许手指滑动
        // effect: 'fade', // 切换方式
        centeredSlides: true,

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        videoSrc: "",
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // preventLinksPropagation: false, // 阻止点击事件冒泡
        // preloadImages: false // 是否强制加载所有图片
      },
      tabList: ["爱心实录", "爱心公益志"],
      lookVideo: false,
      handleScroll: 0,
      pausedPlayState: false,
    };
  },
  components: { Tabs, MySwiper },
  methods: {
    goMore() {
      console.log("000");
      this.$router.push({
        name: "alllove",
      });
    },
    onMouseEvent(bol) {
      // 无线滑动插件 鼠标移动停止
      this.pausedPlayState = bol;
    },
    more() {
      this.isOpen = true;
      console.log(this.open);
    },
    goLookVideo(id) {
      this.lookVideo = true;
      this.chosenList.forEach((item) => {
        if (item.id == id) {
          this.videoSrc = item.video_path;
        }
      });
      console.log(this.chosenList);
      //   var body = document.getElementsByTagName("body")[0];
      //   body.style.overflow = "hidden";
    },
    backLovexz() {
      this.lookVideo = false;
    },
    goDetailArticle(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
          type: "article",
          scene: 2,
          nav_id: 0,
          keyword: "",
        },
      });
    },
    getData() {
      getKindnessIndex().then((res) => {
        this.navList = res.data.nav;
        this.kindness = res.data.kindness;
        this.chosenList = res.data.chosen;
        this.initSlidebar();
      });
    },
    initSlidebar() {
      if (this.chosenList.length < 10) {
        const doms =
          this.$refs.rotationImg.querySelectorAll(".vifnslb-element");
        doms.forEach((el) => (el.style.animationPlayState = "paused"));
        this.isSlide = false;
      } else {
        this.isSlide = true;
      }
    },
  },
  computed: {
    ...mapState({
      // navList: (state) => state.kindness.nav,
      // kindness: (state) => state.kindness.kindness,
      // chosenList: (state) => state.kindness.chosen,
      pictureData: (state) => state.material.pictureData,
    }),
    chosenList_one() {
      return this.chosenList.filter((item, i) => i % 2 == 0);
    },
    chosenList_two() {
      return this.chosenList.filter((item, i) => i % 2 != 0);
    },
  },
  watch: {
    "$store.state.kindness.kindness": {
      deep: true,
      handler(newKindnessData) {
        this.newValue = newKindnessData.content.substring(0, 100) + "...";
      },
    },
    pausedPlayState(val) {
      if (this.isSlide) {
        const value = val ? "paused" : "running";
        const doms =
          this.$refs.rotationImg.querySelectorAll(".vifnslb-element");
        doms.forEach((el) => (el.style.animationPlayState = value));
      }
    },
  },
  mounted() {
    // this.$store.dispatch("getKindnessData");
    this.getData();
    this.$store.dispatch("getPicture");
  },
};
</script>

<style scoped lang="stylus">
.lovexz_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .swiper {
    width: 100%;
    height: 560px;

    .swiper-wrapper {
      .slide-img {
        width: 100%;
        height: 100%;
      }
    }

    .my_pagination {
      :deep(.swiper-pagination-bullet:focus ) {
        outline: none;
      }

      :deep(.swiper-pagination-bullet-active ) {
        opacity: 1;
        background-clip: content-box;
        background: rgba(255, 255, 255, 0.5);
      }

      :deep(.swiper-pagination-bullet-active:before ) {
        content: '';
        position: absolute;
        height: 4px;
        left: 0;
        top: 0;
        width: 0;
        opacity: 1;
        background: #ffffff;
        border-radius: 2px;
        background-clip: content-box;
        -webkit-animation: bannerProgress 7.3s ease-in-out;
        -moz-animation: bannerProgress 7.3s ease-in-out;
        -o-animation: bannerProgress 7.3s ease-in-out;
        -ms-animation: bannerProgress 7.3s ease-in-out;
        animation: bannerProgress 7.3s ease-in-out;
        z-index: 186;
        overflow: hidden;
      }

      :deep(.swiper-pagination-bullet ) {
        position: relative;
        margin: 20px 10px;
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.5);
        opacity: 1;
        width: 50px;
        height: 4px;
        background-clip: content-box;
        z-index: 168;
        top: -3px;
      }
    }
  }

  @keyframes bannerProgress {
    100% {
      width: 50px;
    }
  }
   .love_btn {
      width: 180px;
      height: 50px;
      // background: linear-gradient(180deg, #2276F1 0%, #014EA2 100%);
      border-radius: 4px;
      font-size: 20px;
      font-family: AlibabaPuHuiTiR;
      color: #014EA2;
      border: 1px solid #014EA2;
      line-height: 50px;
      text-align: center;
      margin-top: 20px;
      cursor:pointer;
      border: 1px solid #014EA2;
      &:hover{
        background: linear-gradient(180deg, #2276F1 0%, #014EA2 100%);
        color:#ffffff
      }
    }
  .lovexz_center {
    width: 1480px;

    .lovexz_title {
      text-align: center;
      line-height: 170px;
      font-size: 50px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      background: -webkit-linear-gradient(left, #2075EE, #014EA2);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .lovexz_img_wrap1 {
      margin-right: -20px;
      margin-bottom: -20px;

      .lovexz_img_wrap2 {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;

        .lovexz_item {
          display: inline-block;
          width: 280px;
          height: 280px;
          margin-right: 20px;
          margin-bottom: 20px;
          overflow: hidden;
          position: relative;
          // display: flex;

          .video_icon {
            width: 60px;
            height: 60px;
            position: absolute;
            top: 110px;
            left: 110px;
          }

          .lovexz_img_item {
            width: 100%;
            transition: all 0.5s;
          }

          .mask_wrap {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: linear-gradient(180deg, rgba(32, 117, 238, 0) 0%, #014EA2 100%);
            display: none;

            .mask {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 140px;
              padding: 0 20px;
              box-sizing: border-box;
              color: #FFF;
              font-weight: 500;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              animation: myanimation 0.5s;

              .mask_detail {
                width: 100%;
                font-size: 20px;
              }

              .mask_look {
                font-size: 14px;
                padding: 20px 0;
              }
            }
          }
        }

        .lovexz_item:hover .lovexz_img_item {
          transform: scale(1.05);
        }

        .lovexz_item:hover .mask_wrap {
          display: block;
        }

        .lovexz_item:hover .mask {
          @keyframes myanimation {
            0% {
              bottom: -140px;
            }

            100% {
              bottom: 0;
            }
          }
        }
      }
    }
  }

  .look_video_mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    .back_lovexz{
      position absolute
      top 20px
      right 20px
      width 40px
      height 40px
      line-height 60px
      font-size 40px
      text-align center
      color #fff
      box-sizing border-box
      font-weight 500
      z-index: 100;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .look_video_box {
      width: 60%;
      height: 80vh;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      video {
        width: 100%;
        max-height: 100%;
      }
    }
  }

  .love_origin {
    width: 1180px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .love_origin_title {
      width: 100%;
      height:36px;
      text-align: center;
      line-height: 36px;
      font-size: 36px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      margin: 60px 0;
    }

    .love_origin_content {
      position: relative;
      font-size: 16px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #192342;
      padding-bottom: 40px;

      .detail {
        color: #014EA2;
        cursor: pointer;
        overflow: visible !import;
      }

      .more {
        height: auto;
      }
    }

    .love_origin_wrap {
      width: 100%;
      font-size: 0;
      display: flex;
      justify-content: space-between;

      .love_origin_item {
        width: 380px;
        margin-bottom: 60px;

        .love_origin_item_img {
          width: 100%;
          height: 285px;
          margin-bottom: 20px;
          transition: all 0.5s;
        }

        .love_origin_item_tit {
          height: 20px;
          width: 100%;
          font-size: 28px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #333;
          text-align: center;
        }
      }

      .love_origin_item:hover .love_origin_item_img {
        transform: scale(1.05);
      }
    }
  }
}
</style>
